import type jsPDF from 'jspdf';
import { NOMBRE_FARMACIA, SISTEMA_DESCRIPCION, type LogoInfo } from '@/lib/marca';

export const COLOR_DARK: [number, number, number] = [31, 46, 44];
export const COLOR_PRIMARY: [number, number, number] = [99, 198, 167];
export const COLOR_SOFT: [number, number, number] = [243, 247, 245];
export const COLOR_LINE: [number, number, number] = [220, 226, 223];

/**
 * Dibuja la marca (logo real o monograma de respaldo) dentro de una caja cuadrada.
 */
export function dibujarMarca(doc: jsPDF, logo: LogoInfo | null, x: number, y: number, size: number): void {
  if (logo) {
    const ratio = logo.width / logo.height || 1;
    let w = size;
    let h = size;
    if (ratio > 1) h = size / ratio;
    else w = size * ratio;
    const ox = x + (size - w) / 2;
    const oy = y + (size - h) / 2;
    try {
      doc.addImage(logo.dataUrl, logo.format, ox, oy, w, h);
      return;
    } catch {
      // si falla el incrustado caemos al monograma
    }
  }

  doc.setFillColor(255, 255, 255);
  doc.roundedRect(x, y, size, size, 2, 2, 'F');
  doc.setFillColor(COLOR_DARK[0], COLOR_DARK[1], COLOR_DARK[2]);
  doc.rect(x + size * 0.42, y + size * 0.16, size * 0.16, size * 0.68, 'F');
  doc.rect(x + size * 0.16, y + size * 0.42, size * 0.68, size * 0.16, 'F');
}

/**
 * Encabezado corporativo para documentos A4 (historial, reportes).
 */
export function dibujarEncabezado(
  doc: jsPDF,
  logo: LogoInfo | null,
  subtitulo: string,
  metaLineas: string[] = [],
): void {
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFillColor(COLOR_DARK[0], COLOR_DARK[1], COLOR_DARK[2]);
  doc.rect(0, 0, pageWidth, 34, 'F');

  dibujarMarca(doc, logo, 14, 8.5, 17);

  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(17);
  doc.text(NOMBRE_FARMACIA, 37, 17.5);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(196, 208, 203);
  doc.text(SISTEMA_DESCRIPCION, 37, 23.5);

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.setTextColor(COLOR_PRIMARY[0], COLOR_PRIMARY[1], COLOR_PRIMARY[2]);
  doc.text(subtitulo, 37, 29);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(178, 190, 185);
  metaLineas.forEach((line, i) => {
    doc.text(line, pageWidth - 14, 12 + i * 5, { align: 'right' });
  });
}